export default "__VITE_ASSET__CdIxDdk4__ 400w, __VITE_ASSET__kCUbjplV__ 800w, __VITE_ASSET__CsGqVnF4__ 1024w";